import { AttributeConfigurationDc, AttributeType, generateId } from "@evergis/api";
import { LayerAttribute } from "../../../components/Dialogs/EditResource/components/Layer/LayerAttributeItem";

export const createNewAttribute = (
  attributeData: Partial<LayerAttribute | AttributeConfigurationDc> = {},
): LayerAttribute => ({
  classified: false,
  columnName: "",
  attributeName: "",
  alias: "",
  type: AttributeType.String,
  isEditable: true,
  isDisplayed: true,
  id: generateId(),
  ...attributeData,
});
